"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = onPlaylistItem;
var _PlayablesMutation = _interopRequireDefault(require("../PlayablesMutation"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function onPlaylistItem() {
  _PlayablesMutation["default"].load.call(this);

  // Reset the LoadTime-Video value to compute it for each playlist item
  // unless video hasn't loaded
  if (this.logger.times.LoadTimeVideo !== -1) {
    if (this.config.autoplay === true) {
      this.logger.times.LoadTimeVideo = performance.now();
    } else {
      this.logger.times.LoadTimeVideo = -1;
    }
  }
  this.emit('playlistItem', {
    index: this.playingIndex
  });
}